import { ProductOption } from "./ProductOption.js";

export const restrictedProductOptions: ProductOption[] = [ProductOption.Figurines];
